<template>
  <div class="circle" :style="circleStyle"></div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    animationDuration?: number
    size?: number
    color?: string
    display?: string
  }>(),
  {
    animationDuration: 1000,
    size: 50,
    color: '#fff',
    display: 'inline-block',
  },
)

const circleStyle = computed(() => {
  return {
    display: props.display,
    borderColor: props.color,
    animationDuration: `${props.animationDuration}ms`,
    height: `${props.size}px`,
    width: `${props.size}px`,
  }
})
</script>

<style scoped>
.circle {
  box-sizing: border-box;
  border-radius: 50%;
  border-bottom: 1.5px solid #ff1d5e;
  border-right: 1.5px solid #ff1d5e;
  border-left: 1px solid #ff1d5e;
  animation: circle-spinner-animation 1200ms linear infinite;
}
@keyframes circle-spinner-animation {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
